import { SiteContextConfig } from "@spartacus/core"
import { INITIAL_CONFIG } from "app/utils/consts"
import { environment } from "environments/environment";

const BASESITE_SPA = 'slb-spa';

export const slbContextConfig = (configurations: { code: string, value: string }[], site: string): SiteContextConfig => {
    const baseSite = configurations?.find(({code}) => code === INITIAL_CONFIG.SPA_ALLOWED_WEBSITES)?.value;
    return {
        context: {
            urlParameters: environment.appConfig.urlParams,
            currency: environment.appConfig.currency,
            language: environment.appConfig.language,
            baseSite: baseSite  ? site === BASESITE_SPA ? baseSite.split(',').reverse() : baseSite.split(',')  : environment.appConfig.baseSite
        }
    }
}   

